import { ReactNode } from 'react';
import { IChildrenProp, IDiv } from 'types/components/components.interface';
import './TopbarPageTemplate.scss';
interface ITopbarPageTemplateProps extends IChildrenProp, IDiv {
  topbar: ReactNode;
  footer?: ReactNode;
  topbarAbsolute?: boolean;
  reverse?: boolean;
}

const TopbarPageTemplate = ({
  children,
  topbar,
  className = '',
  footer,
  topbarAbsolute = false,
  reverse,
  ...props
}: ITopbarPageTemplateProps) => {
  return (
    <div
      style={props.style}
      className={`topbar-tabs-template ${reverse ? 'reverse' : ''} ${
        topbarAbsolute ? 'topbar-absolute' : ''
      }`}>
      <div className='topbar'>{topbar}</div>
      <div {...props} className={`tab-content ${className}`}>
        {children}
      </div>
      {footer && <div className='footer'>{footer}</div>}
    </div>
  );
};

export default TopbarPageTemplate;
